import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";
import { Spinner } from "react-bootstrap";
import { InfoTileModel } from "../../shared/models/infoTile.model";
import "./info-tile.scss";

const InfoTileComponent: FC<InfoTileModel> = ({
  title,
  value,
  valueWidth,
  onClickEvent,
  className,
  isLoading = false,
  tooltip,
  subtitle,
  isRefreshButton = false,
  onClick,
}) => {
  const classes = `ms-2 info-value ${className}`;

  const isClickable = Boolean(onClickEvent);

  const Wrapper = isClickable ? "button" : "span";

  const getValue = (value: any) => {
    if (Number.isNaN(value)) {
      return "-";
    }
    return value;
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        marginBottom: "1rem",
      }}
    >
      <div
        className="info-key d-flex"
        style={{ flex: 1, textAlign: "start", wordBreak: "break-word" }}
      >
        <div style={{ width: "100%", wordBreak: "break-word" }}>
          {title}

          {isRefreshButton ? (
            <>
              {isLoading ? (
                <Spinner
                  animation="border"
                  variant="primary"
                  size="sm"
                  className="ms-2"
                />
              ) : (
                <FontAwesomeIcon
                  icon={faRefresh}
                  className="fs-7 ms-2"
                  title="Refresh"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onClick?.();
                  }}
                />
              )}
            </>
          ) : null}

          {subtitle && <div style={{ fontSize: "12px" }}>({subtitle})</div>}
        </div>
        :
        {/* {tooltip && (
          <div className="custom-tooltip">
            <FontAwesomeIcon
              icon={faInfoCircle}
              style={{
                fontSize: "12px",
              }}
              className="me-1 ms-1 mt-1"
            />
            <span className="tooltiptext">{tooltip}</span>
          </div>
        )} */}
      </div>
      <Wrapper
        className={classes}
        style={{
          width: valueWidth ?? "50%",
          textAlign: "end",
          wordBreak: "break-word",
          ...(isClickable && {
            cursor: "pointer",
            background: "none",
            border: "none",
            padding: 0,
            margin: 0,
          }),
        }}
        {...(isClickable && { type: "button" })}
        onClick={() => onClickEvent?.(title)}
      >
        {isLoading ? (
          <Spinner animation="border" variant="primary" size="sm" />
        ) : (
          getValue(value)
        )}
      </Wrapper>
    </div>
  );
};

export default InfoTileComponent;
